import { useTranslation } from 'react-i18next'

interface Props {
  onSnooze: (until: string) => void
}

function getSnoozeDate(option: string): string {
  const now = new Date()
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())

  switch (option) {
    case 'tomorrow': {
      const d = new Date(today)
      d.setDate(d.getDate() + 1)
      return d.toISOString()
    }
    case 'in3days': {
      const d = new Date(today)
      d.setDate(d.getDate() + 3)
      return d.toISOString()
    }
    case 'nextMonday': {
      const d = new Date(today)
      d.setDate(d.getDate() + ((8 - d.getDay()) % 7 || 7))
      return d.toISOString()
    }
    case 'nextWeek': {
      const d = new Date(today)
      d.setDate(d.getDate() + 7)
      return d.toISOString()
    }
    default:
      return new Date(today.getTime() + 86400000).toISOString()
  }
}

const OPTIONS = ['tomorrow', 'in3days', 'nextMonday', 'nextWeek'] as const

export default function SnoozeOptions({ onSnooze }: Props) {
  const { t } = useTranslation('followups')

  return (
    <div className="flex flex-wrap gap-2 mt-3 pt-3 border-t border-white/5">
      {OPTIONS.map(opt => (
        <button
          key={opt}
          onClick={() => onSnooze(getSnoozeDate(opt))}
          className="px-3 py-1.5 rounded-lg bg-indigo-400/10 text-indigo-400 text-xs font-medium hover:bg-indigo-400/20 transition-colors"
        >
          {t(`snooze.${opt}`)}
        </button>
      ))}
    </div>
  )
}
